module.exports = __webpack_public_path__ + "2a94181159fb43f2108081efd5d886a8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-13.png
// module id = 2247
// module chunks = 0